import { Badge, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import { AvailabilityState, getAvailabilityBadgeKey } from "utils/availability-utils";

interface AvailabilityBadgeProps {
    state?: AvailabilityState | null;
    mt?: ThemeSpaceVariable;
}

// Not themed: every colour token is a free hex field in BookingAdmin, so a themed status badge can
// be configured into the brand colour it has to stand apart from.
const BADGE_BACKGROUND = "#C6C6C6";
const BADGE_TEXT = "#151411";

function AvailabilityBadge({ state, mt }: AvailabilityBadgeProps) {
    const { t } = useTranslation();
    const badgeKey = getAvailabilityBadgeKey(state ?? null);

    if (!badgeKey) return null;

    return (
        // @ts-expect-error casper's Badge types expose only the preset variants, not bg/color.
        <Badge mt={mt} bg={BADGE_BACKGROUND} color={BADGE_TEXT}>
            {t(badgeKey)}
        </Badge>
    );
}

export { AvailabilityBadge };
